<template>
    <div id='osd' v-show='obj' class='media-wrapper'
        v-prevent-scroll='{
            "toggle": typeof obj === "undefined" || obj == null,
            "element": prevent_scroll_element
        }'>
        <div class='media-container'>
            <!-- Close -->
            <a class='pull-right exit clickable' title="Close" @click='selected = 0; images = []; media = []; obj = null;'>
                <img src="/images/X_large_white.svg">
            </a>

            <div class='pull-right content-wrapper' :class="{'one-media-only-width': media.length == 1}">

                <!-- OpenSeaDragon Viewer -->
                <open-seadragon :images='images' :selected='selected'></open-seadragon>

                <!-- PDF Viewer -->
                <pdf-viewer :selected='selected' :images='images' :media='media[selected]'></pdf-viewer>

                <!-- Google Drive Viewer -->
                <google-drive :selected='selected' :images='images' :media='media[selected]'></google-drive>

                <!-- Video -->
                <video-player :media='media[selected]'></video-player>

                <!-- Audio -->
                <audio-player :media='media[selected]'></audio-player>

                <!-- Download -->
                <download-file :media='media[selected]'></download-file>
            </div>


            <!-- Mobile Title -->
            <div v-if='media[selected]' v-show='mobile_manager.mobile_view' class='pull-right about'>
                <div><strong>{{media[selected].title}}</strong></div>
                <p>{{media[selected].description}}</p>
            </div>

            <!-- Reference Thumbnails -->
            <div v-show='media.length > 1' id='osd-thumbnails' class='pull-left reference hidden-print'
                v-incremental-scroll='{back: indexBack, forward: indexForward, is_horz: mobile_manager.mobile_view}'>
                <div :class='{"pull-left": mobile_manager.mobile_view, "arrows": mobile_manager.mobile_view}' class='clickable incremental-scroll-back'>
                    <img :class='{"rotate90": !mobile_manager.mobile_view}' src='/images/arrow_large_white.svg'>
                </div>
                <div class='scroll-wrapper'>
                    <div v-for='(m, index) in media'>
                        <img class='thumbnails clickable'
                            @click='selectMedia(index)'
                            :src="m.thumbnail_path"
                            :class='{"selected": selected == index}'>
                    </div>
                </div>
                <div :class='{"pull-right": mobile_manager.mobile_view, "arrows": mobile_manager.mobile_view}' class='clickable incremental-scroll-forward'>
                    <img :class='{"rotate270": !mobile_manager.mobile_view, "rotate180": mobile_manager.mobile_view}'
                        src='/images/arrow_large_white.svg'>
                </div>
            </div>

            <!-- Desktop Title -->
            <div v-if='media[selected]' v-show='!mobile_manager.mobile_view' class='pull-right about' :class="{'one-media-only-width': media.length == 1}">
                <div><strong>{{media[selected].title}}</strong></div>
                <p>{{media[selected].description}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import EventHub from './eventHub.js'
    import MobileManager from './mobileManager.js'
    import mediaParser from '../mixins/mediaParser.js'
    import PdfViewerVue from './pdfViewer.vue'
    import GoogleDriveViewerVue from './googleDriveViewer.vue'
    import OpenSeadragonVue from './openSeadragon.vue'
    import DownloadFileVue from './downloadFile.vue'
    import AudioPlayerVue from './audioPlayer.vue'
    import VideoPlayerVue from './videoPlayer.vue'

    export default {
        props: ['object'],
        mixins: [mediaParser],
        components: {
            'pdf-viewer': PdfViewerVue,
            'google-drive': GoogleDriveViewerVue,
            'open-seadragon': OpenSeadragonVue,
            'download-file': DownloadFileVue,
            'audio-player': AudioPlayerVue,
            'video-player': VideoPlayerVue,
        },
        data: function () {
            return {
                obj: this.object,
                title: null,
                media: [],
                images: [],
                selected: 0,
                mobile_manager: MobileManager,
                prevent_scroll_element: this.$route.name == 'object' ? '#detail' : 'html'
            }
        },
        beforeDestroy: function () {
            $(document).off('keyup')
            EventHub.$off('view-enlarged')
        },
        created: function () {
            var self = this
            EventHub.$on('view-enlarged', this.reload)

            // esc will close
            $(document).keyup(function(e) {
                if (e.keyCode === 27) {
                    self.selected = 0
                    self.obj = null
                }
            })
        },
        watch: {
            $route: function (to, from) {
                this.prevent_scroll_element = to.name == 'object' ? '#detail' : 'html'
                this.selected = 0
                this.obj = null
            }
        },
        methods: {
            selectMedia: function (index) {
                this.selected = index
            },
            indexBack: function () {
                var index = this.selected - 1
                if (index < 0) {
                    this.selectMedia(this.media.length - 1)
                    return
                }

                this.selectMedia(index)
            },
            indexForward: function () {
                var index = this.selected + 1
                if (index >= this.media.length) {
                    this.selectMedia(0)
                    return
                }

                this.selectMedia(index)
            },
            reload: function (params) {
                this.obj = params.object
                this.media = this.parseMedia(this.obj, 100, 100)
                this.images = this.parseImages(this.obj, 100, 100)

                if (this.obj.searchable.title) {
                    this.title = this.obj.searchable.title[0]
                }

                // Go to selected media
                this.selectMedia(params.selected ? params.selected : 0)
            }
        }
    }
</script>

<style scoped>
    .media-wrapper {
        background-color: rgba(0, 0, 0, 0.8);
        position: fixed;
        z-index: 15;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    .media-container {
        margin-left: auto;
        margin-right: auto;
        width: 90%;
        height: 100%;
    }

    .one-media-only-width {
        width: 100% !important;
    }

    .content-wrapper {
        margin-bottom: 10px;
        margin-top: 5%;
        width: 80%;
        height: 75%;

        /* apply if less than 992px (bootstrap large) */
        @media (max-width: 991px) {
            width: 100%;
            height: 65%;

        }
    }

    .arrows {
        position: absolute;
        transform: translateY(-50%);
        top: 50%;
        padding-top: 30px;
        padding-bottom: 30px;
    }

    .reference {
        height: 75%;
        margin-top: 2%;
        white-space: nowrap;
        position: relative;

        .scroll-wrapper {
            overflow: hidden;
        }

        .incremental-scroll-back, .incremental-scroll-forward {
            text-align: center;
        }

        /* apply if less than 992px (bootstrap large) */
        @media (max-width: 991px) {
            margin-top: 10px;
            width: 100%;
            height: initial;

            .scroll-wrapper {
                margin-right: 20px;
                margin-left: 20px;
                overflow-y: auto;
                overflow-x: hidden;

                div {
                    display: inline;
                }
            }

            .incremental-scroll-forward {
                right: 0;
            }
        }
    }

    .about {
        color: white;
        height: 15%;
        width: 80%;
        text-align: left;
        overflow: auto;

        /* apply if less than 992px (bootstrap large) */
        @media (max-width: 991px) {
            height: initial;
            width: 100%;
            text-align: center
        }
    }

    .exit {
        position: absolute;
        z-index: 16; /* the buttons default to behind the canvas */
        right: 5%;
        top: 2%;

        /* apply if less than 992px (bootstrap large) */
        @media (max-width: 991px) {
            top: 15px;
            right: 15px;
        }
    }

    .thumbnails {
        width: 100px;
        padding: 5px;
    }

</style>
